export const endpoint = {
  API_BASE_URL: "https://velvet.clouddeploy.in",
  SEND_OTP: "/api/auth/request-otp",
  VERIFY_OTP: "/api/auth/verify-otp",
  GET_PRODUCTS: "/api/playground/products",
  GET_FILTER_OPTIONS: "/api/playground/filter-options",
  GET_MODELS: "/api/playground/models",
  GET_BACKGROUNDS: "/api/playground/backgrounds",
  GET_GENERATION_OPTIONS: "/api/playground/generation-options",
  GET_GENERATION_COUNT: "/api/image-generation/generation-count",
  GENERATE_IMAGE: "/api/image-generation/generate",
  VIRTUAL_TRY_ON: "/api/image-generation/virtual-try-on",
  DELETE_PRODUCT: "/api/products",
  DELETE_MODEL: "/api/models",
  DELETE_BACKGROUND: "/api/backgrounds",
  QUEUE_TASKS: "/api/queue-tasks",
  QUEUE_TASKS_GENERATE: "/generate",
  QUEUE_TASKS_GENERATION_STATUS: "/generation-status",
  GET_SHOW_AND_TELL: "/api/show-tell",
  GET_COMPARISON_RESULTS: "/api/comparisons",
  GET_CALCULATION_DATA: "/api/calculation-sheet",
  UPLOAD_MODEL: "/api/models/upload",
  UPLOAD_BACKGROUND: "/api/backgrounds/upload",
  UPLOAD_PRODUCT: "/api/products/upload",
  BULK_UPLOAD_PRODUCTS: "/api/products/bulk-upload",
  BULK_UPLOAD_PRODUCT_IMAGES: "/api/products/bulk-images",
  GET_FILTER_CATEGORIES: "/api/categories/filters",
  GET_COLLECTION_CATEGORIES: "/api/categories/collections",
  IMAGE_DOWNLOAD: "/api/image/download",
  TOGGLE_SHOW_TELL_SLIDE: "/api/show-tell/slide",
  TOGGLE_BACKGROUND: "/api/backgrounds",
  TOGGLE_MODEL: "/api/models",
  TOGGLE_PRODUCT: "/api/products",
  TOGGLE_CATEGORY: "/api/categories",
  UPDATE_PRODUCT: "/api/products",
  UPDATE_MODEL: "/api/models",
  UPDATE_BACKGROUND: "/api/backgrounds",

  // AI Model Generation APIs
  GENERATE_AI_MODEL: "/api/models/generate",
  GET_AI_MODEL_HISTORY: "/api/models/generate/history",
  GET_AI_MODEL_STATUS: "/api/models/generate/status",
  SAVE_AI_MODEL_TO_LIBRARY: "/api/models/generate",
  DELETE_AI_MODEL_HISTORY: "/api/models/generate/history",

  // AI Background Generation APIs
  GENERATE_AI_BACKGROUND: "/api/backgrounds/generate",
  GET_AI_BG_HISTORY: "/api/backgrounds/generate/history",
  GET_AI_BG_STATUS: "/api/backgrounds/generate/status",
  SAVE_AI_BG_TO_LIBRARY: "/api/backgrounds/generate",
  DELETE_AI_BG_HISTORY: "/api/backgrounds/generate/history",
};

